declare const __APP_VERSION_CODE__: number;
declare const __APP_VERSION_NAME__: string;
declare const __APP_VERSION_SOURCE__: string;

export const APP_VERSION_CODE: number =
  typeof __APP_VERSION_CODE__ !== "undefined" ? __APP_VERSION_CODE__ : 1;

export const APP_VERSION_NAME: string =
  typeof __APP_VERSION_NAME__ !== "undefined" ? __APP_VERSION_NAME__ : "0.0.0";

export const APP_VERSION_SOURCE: string =
  typeof __APP_VERSION_SOURCE__ !== "undefined" ? String(__APP_VERSION_SOURCE__) : "fallback";

export function appendAppVersionHeaders(
  headers: Record<string, string> | Headers | any = {}
): Record<string, string> {
  const out: Record<string, string> = {};
  if (headers != null && typeof headers === "object") {
    if (typeof headers.entries === "function") {
      try {
        for (const [k, v] of headers.entries()) {
          out[String(k)] = String(v);
        }
      } catch {}
    } else {
      for (const k of Object.keys(headers)) {
        const v = (headers as any)[k];
        if (v != null) out[String(k)] = String(v);
      }
    }
  }
  out["X-App-Version-Code"] = String(APP_VERSION_CODE);
  out["X-App-Version-Name"] = APP_VERSION_NAME;
  return out;
}
